import moment from "moment";
import { EmergencyClass } from "@/js/value-objects/emergency-class";

class EvacueeStatus {
  constructor(disaster) {
    this.disaster = disaster;
  }
  getDisasterNo() {
    if (this.hasDisaster()) {
      return this.disaster.disaster_no;
    }
    return "";
  }
  hasDisaster() {
    return this.disaster && this.disaster.disaster_no;
  }
  hasEmergencyClass() {
    return this.disaster && this.disaster.emerg_cls;
  }
  hasEmergencyClassName() {
    return this.emergencyClassName();
  }
  emergencyClassName() {
    if (this.hasEmergencyClass()) {
      return EmergencyClass.factory(
        this.disaster.emerg_cls
      ).toNameForEvacueeStatus();
    }
    return "";
  }
  datetime() {
    return moment().format("YYYY年MM月DD日 HH:mm ") + "時点";
  }
}

const install = Vue => {
  Vue.prototype.$evacueeStatus = {
    factory(disaster) {
      return new EvacueeStatus(disaster);
    },
    getByMunicipality(items, municipality) {
      const results = [];
      if (items && Array.isArray(items) && items.length > 0) {
        items.forEach(item => {
          if (
            item.eva_area_info &&
            Array.isArray(item.eva_area_info) &&
            item.eva_area_info.length > 0
          ) {
            const hasItem = item.eva_area_info.some(info => {
              return info.eva_municip_code === municipality;
            });
            if (hasItem) {
              results.push(item);
            }
          }
        });
        return results;
      }
      return items;
    }
  };
};
export default {
  install
};
